import { getProp } from "../util/object.js";
import { mapDictionary } from "../util/transform.js";
import { Feedback } from "./Feedback.js";
/** Feedback with a list of sub-feedbacks. */
export class Feedbacks extends Feedback {
    /** List of sub-feedbacks. */
    feedbacks;
    /** List of sub-messages. */
    get messages() {
        return mapDictionary(this.feedbacks, getProp, "message");
    }
    constructor(feedbacks, value) {
        const first = Object.values(feedbacks)[0];
        super(first?.message || "Unknown error", value);
        this.feedbacks = feedbacks;
    }
}
